import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}

interface PostLoginBody {
  email: string;
  password: string;
}

export const DocApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getDoc: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        length?: number;
        start?: number;
      }
    >({
      query: ({ length, search, start }) => ({
        url: `${END_POINTS.getOCR}?start=${start}&length=${length}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getDocById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getOCRById}${id}/`,
        method: "GET",
      }),
    }),
    addDoc: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.docOCR,
        method: "POST",
        body,
      }),
    }),
    updateDoc: builder.mutation<CommonResponseType, { body: any; id: number }>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateOCR}?id=${id}`,
        method: "POST",
        body,
      }),
    }),

    deleteDoc: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteOCR}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetDocQuery,
  useLazyGetDocByIdQuery,
  useAddDocMutation,
  useUpdateDocMutation,
  useDeleteDocMutation,
} = DocApi;
